module.exports = __webpack_public_path__ + "static/img_4660-c089a3f320a6bf2df4a9db80019fb8b6.webp";